/**
 * 工作日设置 API
 */
import apiClient from './config';
import { WorkingDay, WorkdayRefreshResponse } from '@/types/workday';

/**
 * 工作日查询参数
 */
export interface GetWorkdaysParams {
  year?: number;
  month?: number; // 1-12
}

/**
 * 工作日查询结果
 */
export interface GetWorkdaysResult {
  data: WorkingDay[];
}

/**
 * 获取工作日列表
 */
export async function getWorkdays(
  params: GetWorkdaysParams = {}
): Promise<GetWorkdaysResult> {
  const response = (await apiClient.get('/workdays', {
    params,
  })) as unknown as {
    success: boolean;
    data: WorkingDay[];
  };
  return {
    data: response.data || [],
  };
}

/**
 * 刷新指定年份的工作日数据
 */
export async function refreshWorkdays(
  year: number
): Promise<WorkdayRefreshResponse> {
  const response = (await apiClient.post('/workdays/refresh', {
    year,
  })) as unknown as WorkdayRefreshResponse;
  return response;
}

/**
 * 更新工作日请求参数
 */
export interface UpdateWorkdayRequest {
  type: '0' | '1' | '2' | '3';
  name?: string | null;
}

/**
 * 更新工作日响应
 */
export interface UpdateWorkdayResponse {
  success: boolean;
  data: WorkingDay;
}

/**
 * 更新单条工作日记录
 */
export async function updateWorkday(
  id: string,
  data: UpdateWorkdayRequest
): Promise<UpdateWorkdayResponse> {
  const response = (await apiClient.put(`/workdays/${id}`, data)) as unknown as UpdateWorkdayResponse;
  return response;
}

/**
 * 工作日信息（简化版，用于工时分配）
 */
export interface WorkdayInfo {
  date: string;        // YYYY-MM-DD
  isWorkday: boolean;  // 是否工作日
}

/**
 * 查询日期范围内的工作日列表（用于工时分配）
 *
 * @param start 开始日期（YYYY-MM-DD）
 * @param end 结束日期（YYYY-MM-DD）
 * @returns 工作日信息列表
 */
export async function getWorkdaysByDateRange(
  start: string,
  end: string
): Promise<WorkdayInfo[]> {
  const response = (await apiClient.get('/workdays', {
    params: {
      start_date: start,
      end_date: end,
    },
  })) as unknown as {
    success: boolean;
    data: WorkdayInfo[];
  };

  return response.data || [];
}
